
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();

  const quickLinks = [
    { name: t('home'), href: '/' },
    { name: t('about'), href: '/about' },
    { name: t('services'), href: '/services' },
    { name: t('licenses'), href: '/licenses' },
    { name: t('contact'), href: '/contact' },
  ];

  const offices = [
    {
      title: t('headOffice'),
      address: t('officeAddress1'),
      phone: t('phone1'),
    },
    {
      title: t('branchOffice'),
      address: t('officeAddress2'),
      phone: t('phone1'),
    },
    {
      title: t('branchOffice2'),
      address: t('officeAddress3'),
      phone: t('phone2'),
    },
    {
      title: t('branchOffice3'),
      address: t('officeAddress4')
    },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 rtl:space-x-reverse mb-4">
              <img 
                src="https://bichatravels.com/assets/images/bicha-logo.png" 
                alt="Bicha Travels" 
                className="h-10 w-auto"
              />
              <span className="text-xl font-bold text-gray-900">Bicha Travels</span>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Your trusted partner for GCC employment opportunities. Connecting skilled professionals with leading employers across Qatar, Oman, Kuwait, Saudi Arabia, and the UAE for over 15 years.
            </p>
            <div className="flex space-x-4 rtl:space-x-reverse">
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors duration-200">
                <i className="ri-facebook-fill text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors duration-200">
                <i className="ri-twitter-fill text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors duration-200">
                <i className="ri-linkedin-fill text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors duration-200">
                <i className="ri-instagram-fill text-xl w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">{t('quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
                  {t('home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
                  {t('about')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
                  {t('services')}
                </Link>
              </li>
              <li>
                <Link to="/events" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
                  {t('events')}
                </Link>
              </li>
              <li>
                <Link to="/licenses" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
                  {t('licenses')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
                  {t('contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">{t('contactInfo')}</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3 rtl:space-x-reverse">
                <i className="ri-phone-line text-blue-600 mt-1 w-4 h-4 flex items-center justify-center"></i>
                <div>
                  <p className="text-gray-600 text-sm">{t('phone1')}</p>
                  <p className="text-gray-600 text-sm">{t('phone2')}</p>
                  {/* <p className="text-gray-600 text-sm">{t('phone3')}</p> */}
                </div>
              </div>
              <div className="flex items-start space-x-3 rtl:space-x-reverse">
                <i className="ri-mail-line text-blue-600 mt-1 w-4 h-4 flex items-center justify-center"></i>
                <div>
                  <p className="text-gray-600 text-sm">{t('email1')}</p>
                  <p className="text-gray-600 text-sm">{t('email2')}</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 rtl:space-x-reverse">
                <i className="ri-map-pin-line text-blue-600 mt-1 w-4 h-4 flex items-center justify-center"></i>
                <p className="text-gray-600 text-sm">{t('officeAddress1')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">
            © 2024 Bicha Travels. {t('allRightsReserved')}
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-700 text-sm mt-4 md:mt-0 transition-colors duration-200"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
